/* Melanie Harris cart timer: counts down once from 10:00 when the cart first has items. It never restarts on reload or on adding items. At 0:00 the cart is emptied. */
(function () {
  var KEY = 'mhCartStart';
  var LIMIT = 600;
  var busy = false;
  function store() { try { var k = '__mh'; localStorage.setItem(k, '1'); localStorage.removeItem(k); return localStorage; } catch (e) { return null; } }
  var ls = store();
  if (!ls) return;
  function get() { var v = parseInt(ls.getItem(KEY), 10); return isNaN(v) ? null : v; }
  function fmt(s) { s = Math.max(0, s); var m = Math.floor(s / 60), r = s % 60; return (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r; }
  function expire() {
    if (busy) return; busy = true;
    fetch('/cart/clear.js', { method: 'POST' }).then(function () { ls.removeItem(KEY); window.location.reload(); }).catch(function () { busy = false; });
  }
  function render() {
    var start = get();
    var els = document.querySelectorAll('[data-mh-time]');
    if (!els.length) return;
    if (start === null) { start = Date.now(); ls.setItem(KEY, String(start)); }
    var left = LIMIT - Math.floor((Date.now() - start) / 1000);
    for (var i = 0; i < els.length; i++) els[i].textContent = fmt(left);
    if (left <= 0) expire();
  }
  function sync() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!c.item_count) { ls.removeItem(KEY); return; }
      var start = get();
      if (start === null) { ls.setItem(KEY, String(Date.now())); return; }
      if (LIMIT - Math.floor((Date.now() - start) / 1000) <= 0) expire();
    }).catch(function () {});
  }
  sync();
  setInterval(render, 1000);
  setInterval(sync, 15000);
})();
